import React, { useState, useEffect } from "react";
import Tab from "./Tab";
import TabSeparator from "./TabSeparator";

export default function TabSelector(props) {
  const {
    optionContents,
    shape,
    setSelectedOption,
    options,
    selectedOption,
  } = props;
  const [selectedIndex, setSelectedIndex] = useState(
    options.indexOf(ensuredOption())
  );

  function ensuredOption() {
    return selectedOption ? selectedOption : options[0];
  }

  function separatorPosition(i) {
    if (shape !== "square") {
      return "none";
    } else if (selectedIndex - i > 1) {
      return "after";
    } else if (i - selectedIndex > 1) {
      return "before";
    } else {
      return "none";
    }
  }
  useEffect(() => {
    const op = options[selectedIndex];
    if (op !== selectedOption) {
      setSelectedOption(options[selectedIndex]);
    }
  }, [selectedIndex]);

  useEffect(() => {
    if (selectedOption) {
      const i = options.indexOf(selectedOption);
      if (i !== selectedIndex) {
        setSelectedIndex(options.indexOf(selectedOption));
      }
    }
  }, [selectedOption]);

  return (
    <div className={"Tab-selector " + shape}>
      {optionContents.map((icon, i) => {
        return (
          <Tab
            dataCy={`${options[i]}-tab`}
            isSelected={selectedIndex === i}
            setSelectedIndex={setSelectedIndex}
            shape={shape}
            tabIndex={i}
            key={i}
            separator={<TabSeparator />}
            separatorPosition={separatorPosition(i)}
          >
            {icon}
          </Tab>
        );
      })}
    </div>
  );
}
